import { equals } from "ramda";

import { colors } from "~/colors.config";
import { getPrismicTime } from "~/utils/prismic-utils.js";
import { getPriorityCampaign, getMaxDiscount } from "~/utils/campaign-utils";

export default {
  data: () => ({
    currentCampaigns: [],
    intervalHandle: null,
    priorityCampaign: { value: null },
  }),

  created() {
    this.campaignSetting = this.$store.state.campaignSetting?.campaign_setting;
    this.setCurrentCampaigns();
  },

  provide() {
    return { priorityCampaign: this.priorityCampaign };
  },

  computed: {
    campaignFor() {
      return this.priorityCampaign.value?.saleTag ?? "";
    },
  },

  methods: {
    /**
     *
     * @param {*} product will come from searchspring/shopify
     */
    getSaleTag({ tags, campaign, price, compareAtPrice }) {
      const priorityCampaign = getPriorityCampaign(tags)(this.currentCampaigns);

      // To find and set the priority campaign that can be used.
      // For campaign tags

      const campaignTags = priorityCampaign?.tags ?? "";
      const tagsMaxDiscount = getMaxDiscount(tags)(campaignTags);
      const maxDiscount =
        tagsMaxDiscount == 0
          ? priorityCampaign?.salePercentage ?? 0
          : tagsMaxDiscount;

      if (priorityCampaign) {
        this.priorityCampaign.value = { ...priorityCampaign, maxDiscount };
        return;
      }

      // For Campaign
      if (campaign.saleColor && campaign.saleTitle) {
        this.priorityCampaign.value = {
          saleColor: campaign.saleColor,
          saleTitle: campaign.saleTitle,
          saleTileTitle: campaign.saleTitle,
          saleTileTitleMobile: campaign.saleTileTitleMobile,
          pdpSaleTitle: "",
          pdpSaleBody: [],
          plpSaleBody: [],
          campaignTitle: "",
          pdpSalePrice: "",
          enhancedUI: false,
          showRRPText: campaign.saleTitle !== "Clearance",
          maxDiscount: 0,
          pdpTileShowRRP: true,
        };
        return;
      }

      // For normal Sale
      const comparing =
        Number(compareAtPrice) && Number(compareAtPrice) > Number(price);

      if (comparing) {
        this.priorityCampaign.value = {
          saleColor: colors.campaign.sale,
          saleTitle: "SALE",
          saleTileTitle: "SALE",
          saleTileTitleMobile: "SALE",
          pdpSaleTitle: "SALE",
          pdpSaleBody: [],
          plpSaleBody: [],
          pdpSalePrice: "",
          enhancedUI: false,
          showRRPText: true,
          maxDiscount: 0,
          pdpTileShowRRP: true,
        };
      }
    },
    getCurrentCampaigns() {
      return this.campaignSetting.filter(
        ({ startTime, endTime, enableCampaign }) =>
          Date.now() >= getPrismicTime(startTime) &&
          Date.now() <= getPrismicTime(endTime) &&
          enableCampaign
      );
    },
    setCurrentCampaigns() {
      this.currentCampaigns = this.getCurrentCampaigns();

      const checkEquality = () => {
        const campaigns = this.getCurrentCampaigns();
        if (!equals(this.currentCampaigns, campaigns)) {
          this.currentCampaigns = campaigns;
        }
      };

      // will stop the campaign if time elapsed by setting this.currentCampaigns = undefined
      // As getCampaign will return undefined in that case
      if (process.client) {
        this.intervalHandle = setInterval(checkEquality, 1000);
      } else {
        // to prevent memory leak do not call setInterval on client
        checkEquality();
      }
    },
  },

  beforeDestroy() {
    clearInterval(this.intervalHandle);
  },
};
